<template>
  <div>
    <el-form label-width="100px">
      <el-row :gutter="1">
        <el-col :lg="8">
          <el-form-item label="品牌:">
            <el-select v-model="searchForm.brand_id">
              <el-option
                v-for="item in option"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8">
          <el-form-item label="系列別:">
            <el-input v-model="searchForm.name" style="width: 50%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="8">
          <el-button type="primary" @click="fetchClass"
            ><i class="el-icon-search"></i>查詢</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <el-row type="flex" justify="end">
      <el-col :lg="4">
        <el-button type="primary" icon="el-icon-plus" @click="dialogFormVisible = true"
          >新增</el-button
        >
        <el-dialog title="新增" :visible.sync="dialogFormVisible" width="30%" center>
          <el-form ref="classForm" :rules="rules" :model="classForm" label-width="90px">
            <el-row type="flex" justify="center" align="middle" :gutter="2">
              <el-col :lg="22">
                <el-form-item label="品牌" inline>
                  <el-select v-model="classForm.brand_id" placeholder="">
                    <el-option
                      v-for="item in option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="編號:" prop="id">
                  <el-input v-model="classForm.id"></el-input>
                </el-form-item>

                <el-form-item label="系列別名:" prop="name">
                  <el-input v-model="classForm.name"></el-input>
                </el-form-item>
                <el-form-item label="是否優惠">
                  <el-switch
                    v-model="classForm.on_sale"
                    @change="handleOnsale"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-text="是"
                    inactive-text="否"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" align="center">
              <el-col :lg="10" :offset="6">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addClass" icon="el-icon-plus"
                  >增加</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :lg="22">
        <el-table
          :data="classList.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
          :header-cell-style="tableHeaderColor"
          empty-text="暫無數據"
        >
          <el-table-column align="center" header-align="center" prop="id" label="編號">
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="name"
            label="系列別"
          >
          </el-table-column>
          <el-table-column
            align="center"
            header-align="center"
            prop="brand_id"
            label="品牌"
          >
            <template slot-scope="scope">
              {{ scope.row.brand_id == 1 ? "N牌" : "S牌" }}
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="編輯">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                circle
                @click="showEdit(scope.$index, scope.row)"
              ></el-button>
              <el-dialog
                title="編輯"
                :visible.sync="dialogVisible"
                v-model="classInfo"
                width="30%"
                center
              >
                <div>
                  <el-form
                    ref="classForm"
                    :rules="rules"
                    :model="classForm"
                    label-width="90px"
                  >
                    <el-row type="flex" justify="center" align="middle" :gutter="2">
                      <el-col :lg="22">
                        <el-form-item label="品牌" inline>
                          <el-select v-model="classInfo.brand_id" placeholder="">
                            <el-option
                              v-for="item in option"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="編號:" prop="name">
                          <el-input v-model="classInfo.id"></el-input>
                        </el-form-item>

                        <el-form-item label="系列別名:" prop="name">
                          <el-input v-model="classInfo.name"></el-input>
                        </el-form-item>
                        <el-form-item label="是否優惠">
                          <el-switch
                            v-model="classInfo.on_sale"
                            @change="handleOnsale"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否"
                          >
                          </el-switch>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row type="flex" align="center">
                      <el-col :lg="10" :offset="6">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="editClass" icon="el-icon-edit"
                          >編 輯</el-button
                        >
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-dialog>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="狀態">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="開啟"
                inactive-text="關閉"
                @change="updateClassStatus(scope.$index, scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total1"
          @current-change="current_change"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { async } from "q";
export default {
  name: "classSearch",
  data() {
    return {
      searchForm: {
        brand_id: null,
        name: "",
        isCreate: "",
      },
      classList: [],
      classForm: {
        name: "",
        brand: 1,
        id: "",
        on_sale: false,
      },
      classInfo: {
        _key: "",
        name: "",
        brand: 1,
        id: "",
        on_sale: false,
      },

      option: [
        {
          label: "N牌",
          value: 1,
        },
        {
          label: "S牌",
          value: 2,
        },
      ],
      dialogVisible: false,
      dialogFormVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "請輸入系列別名",
          },
        ],
        id: [
          {
            required: true,
            message: "請輸入系列別編號",
          },
        ],
      },
      total1: 0,
      currentPage: 1,
      pagesize: 10,
    };
  },
  computed: mapGetters(["getClassList", "getClassError", "getClassMsg"]),
  methods: {
    ...mapActions(["fetchClassList", "classUpdateStatus", "addClass", "classUpdate"]),
    fetchClass: async function () {
      this.isCreate = "非創造";
      const data = await {
        brand_id: this.searchForm.brand_id,
        name: this.searchForm.name,
        is_create: this.searchForm.isCreate,
      };
      await this.$store.dispatch("fetchClassList", data);
      this.classList = await this.getClassList;
      this.total1 = await this.classList.length;
    },
    async updateClassStatus(index, row) {
      const data = await {
        _key: row._key,
        status: row.status,
      };
      await this.$store.dispatch("classUpdateStatus", data);
      if (this.getClassError == true) {
        await this.$notify({
          title: "失敗",
          message: "無法變更狀態",
          type: "error",
          duration: "4500",
          position: "top-right",
        });
      } else {
        await this.$notify({
          title: "成功",
          message: "變更狀態成功",
          type: "success",
          duration: "4500",
          position: "top-right",
        });
      }
    },
    async addClass() {
      const data = await {
        name: this.classForm.name,
        id: this.classForm.id,
        brand_id: this.classForm.brand_id,
      };
      await this.$store.dispatch("addClass", data);
      if (this.getClassError == true) {
        this.$notify({
          title: "失敗",
          message: this.getClassMsg,
          type: "info",
          duration: "4500",
          position: "top-right",
        });
      } else {
        this.$notify({
          title: "成功",
          message: "新增成功",
          type: "success",
          duration: "4500",
          position: "top-right",
        });
        this.dialogFormVisible = false;
      }
    },
    async editClass() {
      const data = {
        _key: this.classInfo._key,
        name: this.classInfo.name,
        id: this.classInfo.id,
      };
      await this.$store.dispatch("classUpdate", data);
      if (this.getClassError == true) {
        this.$notify({
          title: "失敗",
          message: this.getClassMsg,
          type: "error",
          duration: "4500",
          position: "top-right",
        });
      } else {
        this.$notify({
          title: "成功",
          message: "修改成功",
          type: "success",
          duration: "4500",
          position: "top-right",
        });
        this.dialogVisible = false;
      }
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `background-color: gray;color: #000;`;
      }
    },
    async showEdit(index, row) {
      if (
        row.id == "SC001" ||
        row.id == "SA001" ||
        row.id == "NC001" ||
        row.id == "NA001"
      ) {
        this.$notify({
          title: "不可編輯",
          message: "此系列別不可編輯",
          type: "error",
          duration: "4500",
          position: "top-right",
        });
      } else {
        this.dialogVisible = true;
        this.classInfo = row;
      }
    },
    handleOnsale() {
      console.log(this.classForm);
    },
  },
};
</script>

<style lang="scss" scoped></style>
